import React, {FunctionComponent} from 'react';
import {Modal} from '@material-ui/core';
import BrowseBrandTreezPrompt from './BrowseBrandTreezPrompt';
import {onBackdropClickWrap} from '~/lib/backdropClickWrap';

interface Props {
    closePrompt: () => void;
    open: boolean;
    redirectToBrandTreez: () => void;
    openProductForm: () => void;
}

export const BrowseBrandTreezPromptModal: FunctionComponent<Props> = (props: Props) => {
    const {closePrompt, open, openProductForm, redirectToBrandTreez} = props;

    return (
        <Modal open={open} onClose={onBackdropClickWrap(closePrompt)}>
            <div>
                <BrowseBrandTreezPrompt
                    openProductForm={openProductForm}
                    redirectToBrandTreez={redirectToBrandTreez}
                />
            </div>
        </Modal>
    );
};
